import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Location } from '@angular/common';

import { AttachementsPluginService } from './attachements-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';

import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'attachement-upload',
    templateUrl: './attachement-upload.component.html',
    standalone: false
})
export class AttachementUploadPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  images: string[] = [];
  loaded = false;
  files: any[] = [];
  public plugin: any;
  public assets: any = [];
  allImages: any[] = [];
  editForm: UntypedFormGroup;
  errorMsg = '';
  public processing = false;

  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: AttachementsPluginService,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
    this.editForm = new UntypedFormGroup({});
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service
      .saveAttachments(this.inspectionId, this.pointId, this.pluginId, this.assets, this.files)
      .subscribe((data) => {
        this.processing = true;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
    this.editForm = new UntypedFormGroup({});
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.assets = this.plugin.config.AttachementDocuments;
    });
  }

  handleInputChange(e: any) {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      file.fileTitle = file.name.replace(/\.[^/.]+$/, '');
      this.files.push(file);
      const reader = new FileReader();

      if (!this.isImage(file.type) && !this.isPdf(file.type)) {
        alert('invalid format');
        return;
      }

      this.loaded = false;

      reader.onload = this.handleReaderLoaded.bind(this, file.type);
      reader.readAsDataURL(file);
    }
  }

  handleReaderLoaded(e: any, type: string) {
    this.loaded = true;
  }

  isImage(type: string): boolean {
    const pattern = /image-*/;
    return type != null && type.match(pattern) && type.match(pattern).length > 0;
  }

  isPdf(type: string): boolean {
    const pattern = /application\/pdf/;
    return type != null && type.match(pattern) && type.match(pattern).length > 0;
  }

  deleteAsset(assetId: string) {
    this.service.deleteFile(this.inspectionId, this.pointId, this.pluginId, assetId).subscribe((data) => {
      this.goToBack();
    });
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  removeAsset(id: string) {
    this.assets = this.assets.filter((a: any) => a.AssetId !== id);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
    }
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId ? this.pointId : -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  deletePlugin(e: any) {
    this.service
      .deleteAttachmentPlugin(
        this.inspectionId,
        this.pointId,
        this.pluginId,
        this.plugin.config.AttachementDocuments.map((a) => a.AssetId)
      )
      .subscribe((success: boolean) => {
        if (success) {
          this.goToBack();
        }
      });
  }
}
